import { getSupport } from '../../shared/get-support';

export default {
  name: 'support',
  static: {
    getSupport,
  },
};
